import axios from "../../../axios"
import { paramsObjToGraphQLParams } from "@/utils/index.js"

export default {
  fetch(queryData) {
    return axios.post('', {
      query: `
        query {
          newsletterCampaigns ${paramsObjToGraphQLParams(queryData)} {
            order_by,
            pagination_page,
            pagination_limit,
            total_pages,
            items {
              id,
              mailchimp_id,
              subject_line,
              from_name,
              reply_to,
              preview_text,
              title,
              content,
              activated,
              created_at,
              updated_at,
              test_sent_at,
              sent_at
            }
          }
        }
      `
    })
  },
  add(campaign) {
    return axios.post('', {
      query: `
        mutation {
          createNewsletterCampaign ${paramsObjToGraphQLParams(campaign)} {
            id,
            mailchimp_id,
            subject_line,
            from_name,
            reply_to,
            preview_text,
            title,
            content,
            activated,
            created_at,
            updated_at,
            test_sent_at,
            sent_at
          }
        }
      `
    })
  },
  update(campaign) {
    return axios.post('', {
      query: `
        mutation {
          updateNewsletterCampaign ${paramsObjToGraphQLParams(campaign)} {
            id,
            mailchimp_id,
            subject_line,
            from_name,
            reply_to,
            preview_text,
            title,
            content,
            activated,
            created_at,
            updated_at,
            test_sent_at,
            sent_at
          }
        }
      `
    })
  },
  delete(campaignId) {
    return axios.post('', {
      query: `
        mutation {
          deleteNewsletterCampaign (
            id: ${campaignId}
          )
        }
      `
    })
  },
  infos(campaignId) {
    return axios.post('', {
      query: `
        query {
          newsletterCampaignInfos (
            id: ${campaignId}
          ) {
            id,
            mailchimp_id,
            subject_line,
            from_name,
            reply_to,
            preview_text,
            title,
            content,
            activated,
            created_at,
            updated_at,
            test_sent_at,
            sent_at,
            mailchimp_infos {
              status,
              emails_sent,
              report_summary {
                opens,
                unique_opens,
                open_rate,
                clicks,
                subscriber_clicks,
                click_rate
              }
            }
          }
        }
      `
    })
  },
  test(campaignId, testEmails) {
    return axios.post('', {
      query: `
        mutation {
          testNewsletterCampaign (
              id: ${campaignId},
              receivers: "${testEmails}"
          )
        }
      `
    })
  },
  send(campaignId) {
    return axios.post('', {
      query: `
        mutation {
          sendNewsletterCampaign (
            id: ${campaignId}
          )
        }
      `
    })
  }
}
